// extracted by mini-css-extract-plugin
export default {"financeAd":"index_financeAd_HP0pG","financeAdText":"index_financeAdText_A9RxB","financeAdPic":"index_financeAdPic_JjvtZ"};